import { RootState } from "@/store/store";
import { budgetDetailsByIdDataSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsByIdDataSelector";
import { getPlannedBudgetsWithLabels } from "@/components/pages/budgets-and-alerts/components/grids/budgets/utils/helpers/getPlannedBudgetsWithLabels";
import { organisationQuarterStartMonthSelector } from "@/store/common/selectors/org-current-settings/organisationQuarterStartMonthSelector";
import { isCurrentPlannedBudgetPeriod } from "@/components/pages/budgets-and-alerts/components/grids/budgets/utils/helpers/isCurrentPlannedBudgetPeriod";
import { budgetDetailsDrawerAccumulatedCostDateSelector } from "@/store/budgets/selectors/details-drawer/accumulated-cost/budgetDetailsDrawerAccumulatedCostDateSelector";

export const budgetDetailsAccumulatedCostBudgetSelector = (
  state: RootState,
) => {
  const details = budgetDetailsByIdDataSelector(state);
  const quarterStartMonth = organisationQuarterStartMonthSelector(state);
  const date = budgetDetailsDrawerAccumulatedCostDateSelector(state);

  if (!details) {
    return 0;
  }

  if (details.type === "fixed") {
    return details.amount ?? 0;
  }

  const { period, planned_amounts, start_date } = details;

  const plannedBudgets = getPlannedBudgetsWithLabels({
    period,
    plannedAmounts: planned_amounts ?? undefined,
    startDate: start_date,
    quarterStartMonth,
  });

  const currentPlannedBudget = plannedBudgets.find((plannedBudget) =>
    isCurrentPlannedBudgetPeriod(
      plannedBudget.label,
      period,
      quarterStartMonth,
      date,
    ),
  );

  return currentPlannedBudget?.amount ?? 0;
};
